<template>
  <div class="filterable-list__list-wrapper">
    <FilterableListTitle/>
    <ul class="filterable-list__list" v-if="newsroomList">
      <FilterableListItem v-for="(item, index) in newsroomList" :key="index" :item="item"/>
    </ul>
    <MoreButton/>
  </div>
</template>


<script>
import FilterableListItem from "./FilterableListItem.vue";
import FilterableListTitle from "./FilterableListTitle.vue";
import MoreButton from "./MoreButton.vue";

export default {
  name: "FilterableList",
  components: {
    FilterableListItem,
    FilterableListTitle,
    MoreButton
  },
  computed: {
    newsroomList() {
      return this.$store.getters.newsData;
    }
  }
};
</script>
